import { API } from '@/utils/api'

export default {
  methods: {
    getBulkReloadMethod() {
      return 'loadMirrors'
    },
    afterDeleteMirrors() {},
    afterDisableMirrors() {},
    async mirrorBulkAction(ids, {
      url,
      payloadKey,
      loadingKey,
      successMsg,
      errorMsg,
      onSuccess,
    }) {
      if (!this.canEdit) return

      const mirrorIds = ids.filter(Boolean)
      if (!mirrorIds.length) return

      try {
        this[loadingKey] = true
        await API.call(url, {
          entity_id: this.project,
          [payloadKey]: mirrorIds.length === 1
            ? { mirror_id: mirrorIds[0] }
            : { mirror_ids: mirrorIds },
        })
        this.$showSuccess(successMsg)
        onSuccess?.()
        const reloadMethod = this.getBulkReloadMethod?.()
        if (reloadMethod && typeof this[reloadMethod] === 'function') {
          await this[reloadMethod](this.project)
        }
      } catch (e) {
        this.$showError(e?.response?.data?.message || errorMsg)
      } finally {
        this[loadingKey] = false
      }
    },
    async deleteMirrors(ids = []) {
      await this.mirrorBulkAction(ids, {
        url: '/$v/mirrors-redirectors/mirrors/delete.json',
        payloadKey: 'delMirrors',
        loadingKey: 'delMirrorLoading',
        successMsg: 'Mirror deleted successfully',
        errorMsg: 'Failed to delete mirror',
        onSuccess: () => {
          this.deleteDialog = false
          this.deleteTarget = null
          this.afterDeleteMirrors?.()
        },
      })
    },
    async disableMirrors(ids = []) {
      await this.mirrorBulkAction(ids, {
        url: '/$v/mirrors-redirectors/mirrors/disable.json',
        payloadKey: 'disableMirrors',
        loadingKey: 'disableMirrorLoading',
        successMsg: 'Mirror disabled successfully',
        errorMsg: 'Failed to disable mirror',
        onSuccess: () => {
          this.disableDialog = false
          this.disableTarget = null
          this.afterDisableMirrors?.()
        },
      })
    },
  },
}
